import { ParseAdapter } from '../abstract/ParseAdapter';
import { Tchekb } from './tchekb.model';

export class Report extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get progress(): number { return this.parseObject.get('progress'); }
    set progress(value: number) { this.parseObject.set('progress', value); }

    get tchekPtr(): Tchekb { return new Tchekb(this.parseObject.get('tchekPtr')); }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value.getParseInstance()); }

    get path(): string { return this.parseObject.get('path'); }
    set path(value: string) { this.parseObject.set('path', value); }

    get signatoryFirstName(): string { return this.parseObject.get('signatoryFirstName'); }
    set signatoryFirstName(value: string) { this.parseObject.set('signatoryFirstName', value); }

    get outReportId(): string { return this.parseObject.get('outReportId'); }
    set outReportId(value: string) { this.parseObject.set('outReportId', value); }

    get signatoryLastName(): string { return this.parseObject.get('signatoryLastName'); }
    set signatoryLastName(value: string) { this.parseObject.set('signatoryLastName', value); }

    get signatoryEmail(): string { return this.parseObject.get('signatoryEmail'); }
    set signatoryEmail(value: string) { this.parseObject.set('signatoryEmail', value); }

    get signatoryCompanyName(): string { return this.parseObject.get('signatoryCompanyName'); }
    set signatoryCompanyName(value: string) { this.parseObject.set('signatoryCompanyName', value); }

    get signatoryLicense(): string { return this.parseObject.get('signatoryLicense'); }
    set signatoryLicense(value: string) { this.parseObject.set('signatoryLicense', value); }

    get signatoryPhone(): string { return this.parseObject.get('signatoryPhone'); }
    set signatoryPhone(value: string) { this.parseObject.set('signatoryPhone', value); }

    get signatorySignature(): Parse.File { return this.parseObject.get('signatorySignature'); }
    set signatorySignature(value: Parse.File) { this.parseObject.set('signatorySignature', value); }

    get contractWay(): 'in' | 'out' { return this.parseObject.get('contractWay'); }
    set contractWay(value: 'in' | 'out') { this.parseObject.set('contractWay', value); }
    get contractWayFormatted(): string { return this.contractWay === 'in' ? 'Entrant' : 'Sortant'; }

    get typeReport(): 'simple' | 'state' { return this.parseObject.get('type'); }
    set typeReport(value: 'simple' | 'state') { this.parseObject.set('type', value); }

    get buildTime(): number { return this.parseObject.get('buildTime'); }
    set buildTime(value: number) { this.parseObject.set('buildTime', value); }

    get tchekDate(): Date { return this.parseObject.get('tchekPtr').get('tchekCreatedAt'); }

    get fuel(): number { return this.parseObject.get('fuel'); }
    set fuel(value: number) { this.parseObject.set('fuel', value); }

    get oldDamages(): boolean { return this.parseObject.get('oldDamages'); }
    set oldDamages(value: boolean) { this.parseObject.set('oldDamages', value); }

    get mileage(): number { return this.parseObject.get('mileage'); }
    set mileage(value: number) { this.parseObject.set('mileage', value); }

    get contractDate(): Date { return this.parseObject.get('contractDate'); }
    set contractDate(value: Date) { this.parseObject.set('contractDate', value); }

    get checklist(): ReportChecklist { return this.parseObject.get('checklist'); }
    set checklist(value: ReportChecklist) { this.parseObject.set('checklist', value); }

    get vehicleChecklist(): ReportVehicleChecklist[] { return this.parseObject.get('vehicleChecklist'); }
    set vehicleChecklist(value: ReportVehicleChecklist[] ) { this.parseObject.set('vehicleChecklist', value); }

    get selectedDamages(): string[] {
        return this.parseObject.get('selectedDamages');
    }
    set selectedDamages(value: string[]) { this.parseObject.set('selectedDamages', value); }

    get reportCreatedAt(): ReportChecklist { return this.parseObject.get('reportCreatedAt'); }
    set reportCreatedAt(value: ReportChecklist) { this.parseObject.set('reportCreatedAt', value); }

    get notes(): string { return this.parseObject.get('notes'); }
    set notes(value: string) { this.parseObject.set('notes', value); }
}

export interface ReportChecklist {
    [name: string]: boolean;
}

export interface ReportVehicleChecklist {
    id : string;
    value : boolean;
 }
 


// WEBPACK FOOTER //
// ./src/app/model/report.model.ts